import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { GraphicAccentGrabber } from './components/GraphicAccentGrabber';
import { GRAPHIC_ACCENT_SCHEMA_URL, GRAPHIC_ACCENT_COMPONENT_TYPE } from './GraphicAccent.constants';

// Lazy load view components
const GraphicAccentAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorGraphicAccentAdd" */ './components/GraphicAccentAdd'), 'GraphicAccentAdd');

const GraphicAccentEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorGraphicAccentEdit" */ './components/GraphicAccentEdit'), 'GraphicAccentEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const GraphicAccentConfig: AdminJsonComponentConfig = {
  schemaUrl: GRAPHIC_ACCENT_SCHEMA_URL,
  componentType: GRAPHIC_ACCENT_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: GraphicAccentAdd,
    dragComponentView: GraphicAccentGrabber,
    editComponentView: GraphicAccentEdit,
    createComponentView: GraphicAccentEdit,
  },
} as const;
